








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import moment from 'moment';

@Component
export default class NavDropdownHeader extends Vue {
	@Prop()
	private nav!: AuthenticatedNav;

	get name(): string {
		if (this.nav && this.nav.fullName) {
			return this.nav.fullName;
		} else {
			return 'Your Account';
		}
	}

	get investorSince(): string | undefined {
		if (this.nav && this.nav.firstInvestmentDate) {
			return moment(this.nav.firstInvestmentDate).format('YYYY');
		}
	}

	get isMultipleEntities(): boolean {
		return this.nav && this.nav.multipleInvestmentEntities;
	}

	get isDesktop(): boolean {
		return app.screenSize === 'DESKTOP';
	}
}
